import { SIGNAL_TYPE_TO_NOTIFICATION_BODY_SUFFIX } from './SignalTypeToBodySuffix';

export const Signals = {
  SIGNAL_TYPE_TO_NOTIFICATION_BODY_SUFFIX,
};
